// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#goldprice[data-v-44b4e180]{height:73.333vw}", ""]);
// Exports
module.exports = exports;
